// extracted by mini-css-extract-plugin
module.exports = {"cancellation-skeleton":"CancellationRulesSkeleton_cancellation-skeleton__2dykc"};